'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyPolicyEn = function (_React$Component) {
    _inherits(PrivacyPolicyEn, _React$Component);

    function PrivacyPolicyEn() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PrivacyPolicyEn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivacyPolicyEn.__proto__ || Object.getPrototypeOf(PrivacyPolicyEn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            companyEnName: 'Beijing Xiaowei Cloud Service Technology Co., Ltd.',
            companyName: 'Beijing Xiaowei Cloud Inc.'
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PrivacyPolicyEn, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = 'DkNote-Privacy Policy';
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            'DkNote'
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'eula' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'title' },
                        'Privacy Policy'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Last updated: October 08, 2023'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Privacy protection statement'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'This document (\u201CDkNote Privacy Policy\u201D) explains the privacy rules applicable to all information collected or submitted when you access, install, or use the our apps and service.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'All definitions and capitalized words used in this Privacy Policy are defined here or in our General Terms. By visiting our websites, by submitting your personal data to us, and by accessing, installing and/or using the Services, you confirm that you have read this Privacy Policy and agree to be bound by this Privacy Policy. If you disagree with the rules of this Privacy Policy, please do not use our Services.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'Information in this Privacy Policy is provided in layers, meaning that all information related to our general personal data processing practices is provided here.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Processing of your data'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'We processes user data to a limited scope \u2013 for provision of the Services, processing payments for the Services, as well as the functioning of our websites and mobile applications. We process the following basic information:'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Information for creating your account'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'Email address: We ask for your email address as part of your registration. It is necessary for establishing an account, retrieving a lost password, and using our Services. Currently, it is not necessary.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Payment related information'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'Payment data (if using paid Services). This information is necessary to collect payments for our Services. Our payment processing partners process basic billing information for payment processing and refund requests (such as date of purchase, payer\u2019s IP address, zip code, card owner\'s full name and credit card information). We also process some of the same payment information ourselves (e. g., order id, IP address, total amount) in cases of recurring payments.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Information collected on our website'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'Access logs. As most websites on the internet, our website collects access logs (such as IP address, browser type, operating system) to operate our services and ensure their secure, reliable, and robust performance. This information is also essential for fighting against DDoS attacks, scanning and similar hacking attempts.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Sharing your personal data'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'We do not share your personal information with third parties except as described in this Privacy Policy.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Data security'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'We take data security very seriously and take all steps reasonably necessary to secure your data (whether technical, physical, or administrative). However, no company can guarantee the absolute security of internet communications. By using the Services, you expressly acknowledge that we cannot guarantee the security of any data provided to or received by us through the Services and that any information received from you through the website or our Services is provided at your own responsibility.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Use third-party SDK'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'In order to ensure the stable and safe operation of the platform, we use Umeng+SDK. After you authorize and agree, we will obtain access to your local device information, MAC address and frequency of use of service functions from you Permission. If you do not authorize, it may affect the security of the service and you may not get a high-quality user experience. You can visit https://www.umeng.com/policy to understand the [Umeng+] privacy policy.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        'Contact us'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        'If you have any questions or concerns about this Privacy Policy, please send an email to: service@xiaoweiyunfu.com'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        this.state.companyName
                    ),
                    _react2["default"].createElement('div', { className: 'part' })
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    'support'
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    'If you have any comments and suggestions, please email us',
                                    _react2["default"].createElement('br', null),
                                    'service@xiaoweiyunfu.com'
                                )
                            ),
                            _react2["default"].createElement('div', { className: 'left' })
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2023 ',
                            this.state.companyEnName,
                            '  \xA0\xA0 ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicyen' },
                                'Privacy Policy'
                            ),
                            ' '
                        )
                    )
                )
            );
        }
    }]);

    return PrivacyPolicyEn;
}(_react2["default"].Component);

exports["default"] = PrivacyPolicyEn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./PrivacyPolicyEn.js
// module id = 385
// module chunks = 0